import React from 'react';
import { Row, Col } from 'antd';
import { Drawer, Button, Icon } from 'antd';
import Explanatory from './content/Explanatory';

class Header extends React.Component {
  state = { visible: false };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    return (
      <div className={this.props.inputClass}>
          <a className="header__spendmap-logo" target="_blank" href="https://app.spendmapp.com.au/" rel="follow">
            <img alt="Brisbane Logo" src="https://s3-ap-southeast-2.amazonaws.com/brisbane-images/logo/spendmap-logo.svg" />
          </a>
          <a className="header__geografia-logo" target="_blank" href="https://geografia.com.au/" rel="follow">
            <img alt="Geografia Logo" src="https://s3-ap-southeast-2.amazonaws.com/brisbane-images/logo/geografia-logo.svg" />
          </a>
          <Icon onClick={this.showDrawer} type="info-circle-o" />
          <Drawer
            title="Help/About"
            width={720}
            placement="right"
            onClose={this.onClose}
            maskClosable={false}
            visible={this.state.visible}
            style={{
              height: 'calc(100% - 55px)',
              overflow: 'auto',
              paddingBottom: 53,
            }}
          >
            <Explanatory />
            <Button onClick={this.onClose} type="primary" className="explanatory">Close</Button>
          </Drawer>
      </div>
  )}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js